import React from 'react';
import PropTypes from 'prop-types';

import PopupV3, { PopupTypes } from '../../Popup/PopupV3';

const TITLE = 'Your Subscription was Purchased Through Apple';

// `message` is rendered via dangerouslySetInnerHTML in PopupV3, so the bold
// path segment is inlined as HTML rather than JSX.
const MESSAGE = 'You can manage your subscription on the UTR Sports app on your iPhone or iPad or through your subscription screen in <strong>Apple Settings &gt; Apple Account &gt; Subscriptions</strong>.';

const AppleSubscriptionPopup = ({ isOpen, onClose }) => (
    <PopupV3
        title={TITLE}
        message={MESSAGE}
        isOpen={isOpen}
        type={PopupTypes.INFO}
        onConfirmClick={onClose}
        onCancelClick={onClose}
        confirmButtonLabel="Got it"
        data-testid="modal.apple-subscription"
    />
);

AppleSubscriptionPopup.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default AppleSubscriptionPopup;
